import * as React from 'react';

import { cn } from '@/new/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'file:text-foreground flex w-full rounded-md border bg-white px-3 py-1.75 text-sm ring-offset-2 transition-colors duration-150 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400/80 focus-visible:ring-1 focus-visible:ring-teal-500 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
